import { render, staticRenderFns } from "./icon-trash.vue?vue&type=template&id=3346c884"
import script from "./icon-trash.vue?vue&type=script&lang=ts"
export * from "./icon-trash.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports